@if (!networkStatusOnline.connected) {
	<div class="network_status_check">
		<p>Du bist Offline</p>
	</div>
}

<ion-app>
	<ion-router-outlet id="content1"></ion-router-outlet>
</ion-app>
